export const compliance = {
  companyName: '百晓生(宜宾)网络科技有限公司',
  icpFilingNumber: '蜀ICP备2026025593号',
  appFilingNumber: '蜀ICP备2026025593号',
  websiteUrl: 'https://www.baxash.com',
  supportEmail: 'baixiaoshengcom@163.com',
  supportPhone: '',
  icpQueryUrl: 'https://beian.miit.gov.cn/',
};

export function contactSummary() {
  let text = `公司名称：${compliance.companyName}\n联系邮箱：${compliance.supportEmail}`;
  if (compliance.supportPhone) {
    text += `\n联系电话：${compliance.supportPhone}`;
  }
  return text;
}

export const privacySections = [
  {
    title: '1. 服务说明',
    body: '百晓生主要提供任务发布、任务接单、私信沟通、聊天室互动、客服工单等基础服务。本政策用于说明应用在提供这些功能时会处理哪些信息，以及这些信息会如何被使用。',
  },
  {
    title: '2. 我们可能收集的信息',
    body: '当你主动填写或使用相关功能时，应用可能处理用户名、昵称、头像、手机号、邮箱、任务内容、私信消息、客服工单内容等信息。除网络连接所必需的信息外，当前版本不默认申请通讯录、短信、定位、麦克风或相册读取权限。',
  },
  {
    title: '3. 权限与用途说明',
    body: '客户端主要通过网络连接访问服务端，用于加载任务、消息、客服与资料数据。如果后续新增系统权限，会在新版本中补充说明，并按照系统规则征求你的授权。',
  },
  {
    title: '4. 信息使用方式',
    body: '前述信息主要用于账号识别、任务展示、消息同步、客服处理、异常排查与基础安全防护。未经你的明确授权，应用不会将你的个人信息用于与当前服务无关的营销用途。',
  },
  {
    title: '5. 信息存储与共享',
    body: '我们会在提供服务所必需的期限内保存相关数据，并采取合理措施保护数据安全。除履行法律法规要求、处理纠纷或完成你发起的服务流程外，不会向无关第三方出售你的个人信息。',
  },
  {
    title: '6. 联系我们',
    body: `如你对隐私政策、数据使用或个人信息处理有疑问，可通过以下方式联系：\n${contactSummary()}`,
  },
];

export const agreementSections = [
  {
    title: '1. 协议适用范围',
    body: '本协议适用于你使用百晓生客户端及其配套服务的全部过程，包括任务浏览、发布、沟通、客服反馈等功能。你下载、安装或使用本应用，即视为同意遵守本协议及相关规则。',
  },
  {
    title: '2. 用户使用规范',
    body: '你应保证提交的信息真实、合法、完整，不得利用平台发布违法违规、侵权、诈骗、骚扰或虚假信息。不得以任何方式干扰应用正常运行、批量抓取数据或冒用他人身份。',
  },
  {
    title: '3. 任务与沟通规则',
    body: '你在平台发布或接取任务时，应自行确认任务内容、金额、沟通方式和履约安排。通过私信、聊天室、客服等功能发布的内容，应遵守法律法规和平台规则，不得传播违法、有害或侵犯他人权益的信息。',
  },
  {
    title: '4. 服务变更与责任说明',
    body: '应用可根据运营安排对功能、页面、服务策略进行调整。因网络故障、系统维护、第三方服务异常等原因导致的短时不可用，平台会尽量恢复，但不承诺绝对无中断运行。涉及交易、纠纷或线下履约的风险，用户应结合实际情况自行判断。',
  },
  {
    title: '5. 联系与争议处理',
    body: `若你对服务规则、账号状态或使用问题存在疑问，可通过应用内客服或以下方式联系：\n${contactSummary()}`,
  },
];
